import Cookies from "Helpers/Cookies.js";

export default () => Cookies.setAll();
